import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setBillingAddress } from "../../store/orderEntitySlice";
import { numValidate } from "../../../shared/helpers/numberValidate";

const Gstin = () => {
    const dispatch = useDispatch();
    const { gstin } = useSelector(
        (state) => state?.orderEntity?.order_billing_addresses[0]
    );
    console.log("pincode", gstin);
    return (
        <>
            <Form.Label>GSTIN</Form.Label>
            <Form.Control
                maxLength={6}
                name="gstin"
                type="text"
                value={gstin}
                onKeyPress={(event) => numValidate(event)}
                onChange={(e) => {
                    let data = {
                        field: "gstin",
                        value: e.target.value,
                    };
                    dispatch(setBillingAddress(data));
                }}
            />
        </>
    );
};

export default Gstin;
